const atualizarMarcas = (state, marcas) => {
    state.marcas = marcas;
}

const atualizarMarca = (state, marca) => {
    state.marca = marca;
}

const addMarca = (state, marca) => {
    if (!marca || marca.id == null) return;

    state.marcas.push(JSON.parse(JSON.stringify(marca)));
}

const updateMarca = (state, marca) => {
    if (!marca || marca.id == null) return;

    const index = state.marcas.findIndex(item => item.id === marca.id);
    if (index >= 0) {
        state.marcas.splice(index, 1, JSON.parse(JSON.stringify(marca)));
    }
}

export default {
    atualizarMarcas,
    atualizarMarca,
    addMarca,
    updateMarca
}
